module.exports = __webpack_public_path__ + "media/images/s03_03_pt-b553442490422464558dd21c4f0416cf.svg";